import { render, staticRenderFns } from "./UPasswordChange.vue?vue&type=template&id=284d431b&scoped=true&"
import script from "./UPasswordChange.vue?vue&type=script&lang=js&"
export * from "./UPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./UPasswordChange.vue?vue&type=style&index=0&id=284d431b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d431b",
  null
  
)

export default component.exports